import { CBadge } from "@coreui/react";
import CIcon from "@coreui/icons-react";
import React from "react";
import { PropTypes } from "prop-types";

//Copies passed prop to clipboard upon a badge click and displays
//checmark if copy to clipboard was successful
export const CopyToClipboardBadge = (props) => {
  const [copied, setCopied] = React.useState(false);
  return (
    <>
      {window.isSecureContext && (
        <CBadge
          color="secondary"
          data-attr="shared:btn:copy-to-clipboard"
          onClick={() => {
            navigator.clipboard.writeText(props.valueToCopy);
            setCopied(true);
          }}
          style={{ cursor: "pointer" }}
        >
          {copied ? <CIcon name="cil-check" /> : "Copy to clipboard"}
        </CBadge>
      )}
    </>
  );
};

CopyToClipboardBadge.propTypes = {
  valueToCopy: PropTypes.string.isRequired,
};

export default CopyToClipboardBadge;
